<template>
  <div class="ad">
    <div class="adRight">
      <div class="add" v-if="addList && addListFlag3">
        <router-link
          :to="{
            path: '/jobDetail',
            query: { jobDetailId: addList[7][0].recruitId },
          }"
        >
          <img :src="addList[7][0].img" alt="" />
        </router-link>
        <p @click="addListFlag3 = false">关闭</p>
      </div>
      <div class="advisory">
        <div
          class="adBlock"
          @mouseover="qqFlag = true"
          @mouseout="qqFlag = false"
        >
          <a
            href="http://wpa.qq.com/msgrd?v=3&uin=421555737&site=qq&menu=yes"
            target="_blank"
            rel="”nofollow”"
          >
            <p><i class="icon iconfont" style="color: #1787fb">&#xe63d;</i></p>
            <p style="color: #666">QQ咨询</p>
          </a>
        </div>
        <div
          class="adBlock"
          @mouseover="telShowFlag = true"
          @mouseout="telShowFlag = false"
        >
          <p><i class="icon iconfont">&#xe601;</i></p>
          <p>联系电话</p>
          <div
            v-show="telShowFlag"
            style="padding-top: 30px; color: #333; height: 100px; top: -24px"
          >
            <p style="line-height: 30px">021-50829828</p>
            <p>联系科研人才网</p>
          </div>
        </div>
        <div
          class="adBlock"
          @mouseover="WeChatFlag = true"
          @mouseout="WeChatFlag = false"
        >
          <p><i class="icon iconfont">&#xe671;</i></p>
          <p>关注微信</p>
          <div v-show="WeChatFlag">
            <p>扫一扫二维码</p>
            <img src="~@/assets/imgs/WechatIMG.jpeg" alt="" />
            <p>关注科研人才网</p>
          </div>
        </div>
        <div class="adBlock" @click="scrollToTop">
          <p style="padding-top: 14px">
            <img src="~@/assets/imgs/Shape 3.png" alt="" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "addif",
  props: {
    fiveListData: {
      // type: Object,
      // default: {}
    },
  },
  data() {
    return {
      qqFlag: false,
      telShowFlag: false,
      WeChatFlag: false,
      addList: {},
      toTopShow: true,
      scrollTop: "",
      addListFlag1: true,
      addListFlag2: true,
      addListFlag3: true,
    };
  },
  methods: {
    handleScroll() {
      let dom = document.documentElement;
      this.scrollTop = dom.scrollTop;
      if (this.scrollTop > 300) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    scrollToTop() {
      let timer = null;
      let _this = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_this.scrollTop > 5000) {
          _this.scrollTop -= 1000;
          document.documentElement.scrollTop = _this.scrollTop;
          timer = requestAnimationFrame(fn);
        } else if (_this.scrollTop > 1000 && _this.scrollTop <= 5000) {
          _this.scrollTop -= 500;
          document.documentElement.scrollTop = _this.scrollTop;
          timer = requestAnimationFrame(fn);
        } else if (_this.scrollTop > 200 && _this.scrollTop <= 1000) {
          _this.scrollTop -= 100;
          document.documentElement.scrollTop = _this.scrollTop;
          timer = requestAnimationFrame(fn);
        } else if (_this.scrollTop > 50 && _this.scrollTop <= 200) {
          _this.scrollTop -= 10;
          document.documentElement.scrollTop = _this.scrollTop;
          timer = requestAnimationFrame(fn);
        } else if (_this.scrollTop > 0 && _this.scrollTop <= 50) {
          _this.scrollTop -= 5;
          document.documentElement.scrollTop = _this.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          _this.toTopShow = false;
        }
      });
    },
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("scroll", this.handleScroll, true);
    });
  },
  destroyed() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  watch: {
    fiveListData: {
      immediate: true,
      handler(val, oldval) {
        this.addList = val;
      },
    },
  },
};
</script>
<style scoped = "scoped"  lang = "less">
.ad {
  position: fixed;
  width: 80px;
  top: 50%;
  left: 50%;
  height: 530px;
  margin-top: -265px;
  margin-left: 606px;
  .add {
    position: relative;
    p {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 30px;
      line-height: 30px;
      background-color: #999;
      color: #fff;
      text-align: center;
      font-size: 14px;
      cursor: pointer;
      display: none;
    }
  }
  .add:hover p {
    display: block;
  }
  .adLeft {
    /* position: fixed; */
    position: absolute;
    top: 50%;
    left: 0;
    width: 80px;
    height: 530px;
    margin-top: -265px;
    img {
      width: 80px;
      height: 288px;
    }
    .add:last-child {
      img {
        height: 220px;
        margin-top: 20px;
      }
    }
  }
  .adRight {
    /* position: fixed; */
    position: absolute;
    top: 50%;
    right: 0;
    width: 80px;
    height: 530px;
    margin-top: -265px;
    img {
      width: 80px;
      height: 288px;
    }
    a:last-child {
      img {
        height: 220px;
        margin-top: 20px;
      }
    }
    .advisory {
      width: 60px;
      /* margin-top: 20px; */
      position: absolute;
      bottom: -20px;
      .adBlock {
        cursor: pointer;
        position: relative;
        width: 60px;
        height: 60px;
        color: #666;
        font-size: 12px;
        background-color: white;
        text-align: center;
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
        padding-top: 10px;
        .iconfont {
          font-size: 24px;
        }
        img {
          width: 20px;
          height: 20px;
        }
        div {
          position: absolute;
          width: 180px;
          height: 170px;
          right: 60px;
          top: -60px;
          background-color: white;
          img {
            width: 120px;
            height: 120px;
          }
        }
      }
      .adBlock:hover {
        .iconfont {
          color: #1787fb;
        }
      }
    }
  }
}
@media all and (max-width: 1360px) {
  .adRight {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/addif.vue